import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CONSTANTS } from '../../../constants';
import { DataService } from '../../../services/data.service';
import { NotificationService } from '../../../services/notification.service';
import { ThreadService } from '../../../services/api/thread.service';

@Component({
  selector: 'strategy-orb-v1',
  templateUrl: './orb-v1.component.html',
  styleUrls: ['./orb-v1.component.scss']
})
export class OrbV1Component implements OnInit, OnDestroy {

  @Input('params')
  params: any;

  admin: any
  edit: any;
  strategy: any;
  strategyParams: any;
  saveSettingsEvent: any;

  categories = [CONSTANTS.DEFAULT.CATEGORY];
  segments = [CONSTANTS.DEFAULT.SEGMENT];
  symbols = [CONSTANTS.DEFAULT.SYMBOL];
  days = CONSTANTS.DAYS;
  intervals = CONSTANTS.INTERVALS;
  ss_segments = CONSTANTS.ORB_SS_SEGMENTS;

  constructor(private dataService: DataService, private notificationService: NotificationService,
    private threadService: ThreadService) { }

  ngOnInit(): void {
    this.admin = sessionStorage.getItem(CONSTANTS.COOKIE.IS_ADMIN);
    this.edit = this.params.edit;
    this.strategy = this.params.strategy;
    this.strategyParams = this.params.strategyParams;
    this.populateDatas();
    this.populateOpenStrategyModal();
    this.saveSettingsEvent = this.dataService.onSaveSettings.subscribe(data => {
      if (data.code == 'orb_v1') {
        this.saveSettings(data.params, data.data);
      }
    });
  }

  onSymbolSelected(params: any) {
    let symbol: any = this.getSymbolByName(params.trading_symbol);
    params.symbol = symbol;
    params.strike_diff = symbol.instrument.option_details.strike_diff;
    this.setSSParams(params, params.ss.type.toLowerCase())
  }

  slTgtTypeClass(params: any, type: any, name: any) {
    if (['tgt_type'].indexOf(name) > -1) {
      if (params.tgt.type == type) {
        return { active: 1 }
      }
    } else if (['tgt_value_type'].indexOf(name) > -1) {
      if (params.tgt.value_type == type) {
        return { active: 1 }
      }
    } else if (['sl_type'].indexOf(name) > -1) {
      if (params.sl.type == type) {
        return { active: 1 }
      }
    } else if (['sl_value_type'].indexOf(name) > -1) {
      if (params.sl.value_type == type) {
        return { active: 1 }
      }
    } else if (name == 'tsl') {
      if (params.tsl.type == type) {
        return { active: 1 }
      }
    } else if (name == 'order_adjustment') {
      if (params.order_adjustment.type == type) {
        return { active: 1 }
      }
    } else if (name == 'order_adjustment_sl') {
      if (params.order_adjustment.sl.type == type) {
        return { active: 1 }
      }
    } else if (name == 'order_adjustment_tgt') {
      if (params.order_adjustment.tgt.type == type) {
        return { active: 1 }
      }
    }
    return { };
  }

  onSLTgtTypeSelect(params: any, type: any, name: any) {
    let texts: any = { pts: 'Points', percent: 'Percent' };
    let t: any;
    if (['tgt_type'].indexOf(name) > -1) {
      params.tgt.type = type;
      t = this.getTypeById(type, params.tgt.types);
      params.tgt.type_text = t.name;
    } else if (['tgt_value_type'].indexOf(name) > -1) {
      params.tgt.value_type = type;
      t = this.getTypeById(type, params.tgt.value_types);
      params.tgt.value_type_text = t.name;
    } else if (['sl_type'].indexOf(name) > -1) {
      params.sl.type = type;
      t = this.getTypeById(type, params.sl.types);
      params.sl.type_text = t.name;
      params.sl.min = t.min;
      params.sl.min_enabled = t.min_enabled;
      params.sl.max_enabled = t.max_enabled;
    } else if (['sl_value_type'].indexOf(name) > -1) {
      params.sl.value_type = type;
      t = this.getTypeById(type, params.sl.value_types);
      params.sl.value_type_text = t.name;
    } else if (name == 'tsl') {
      params.tsl.type = type;
      params.tsl.type_text = texts[type];
    } else if (name == 'order_adjustment') {
      params.order_adjustment.type = type;
      params.order_adjustment.type_text = texts[type];
    } else if (name == 'order_adjustment_sl') {
      params.order_adjustment.sl.type = type;
      params.order_adjustment.sl.type_text = texts[type];
    } else if (name == 'order_adjustment_tgt') {
      params.order_adjustment.tgt.type = type;
      params.order_adjustment.tgt.type_text = texts[type];
    }
  }

  slTgtClass(params: any, name: any) {
    if (name == 'tgt') {
      let tgt_enabled: any = (params.tgt.state == 'enabled');
      if (tgt_enabled) {
        return { 'text-primary': 1 };
      }
    } else if (name == 'sl') {
      let sl_enabled: any = (params.sl.state == 'enabled');
      if (sl_enabled) {
        return { 'text-primary': 1 };
      }
    } else if (name == 'tsl') {
      if (params.tsl.state == 'enabled') {
        return { 'text-primary': 1 };
      }
    } else if (name == 'order_adjustment') {
      if (params.order_adjustment.state == 'enabled') {
        return { 'text-primary': 1 };
      }
    }
    return { 'text-secondary': 1 };
  }

  onSLTgtPanelClick(params: any, name: any) {
    let names: any = [];
    if (name == 'tgt') {
      let tgt_collapsed: any = (params.tgt.content == 'collapse');
      if (tgt_collapsed) {
        params.tgt.collapsed = !params.tgt.collapsed;
      }
      names = ['tgt'];
    } else if (name == 'sl') {
      let sl_collapsed: any = (params.sl.content == 'collapse');
      if (sl_collapsed) {
        params.sl.collapsed = !params.sl.collapsed;
      }
      names = ['sl'];
    } else if (name == 'tsl') {
      if (params.tsl.content == 'collapse') {
        params.tsl.collapsed = !params.tsl.collapsed;
      }
      names = [name];
    } else if (name == 'order_adjustment') {
      if (params.order_adjustment.content == 'collapse') {
        params.order_adjustment.collapsed = !params.order_adjustment.collapsed;
      }
      names = [name];
    }
    for (let i = 0; i < names.length; i++) {
      this.updateSLTgtContent(params, names[i]);
    }
  }

  updateSLTgtContent(params: any, name: any) {
    if (['tgt'].indexOf(name) > -1) {
      this.strategyParams = this.setTgtParams(params);
    } else if (['sl'].indexOf(name) > -1) {
      this.strategyParams = this.setSLParams(params);
      if (params.sl.state == 'disabled') {
        if (name == 'sl') {
          params.tsl.state = 'disabled';
          params = this.setTSLParams(params, params.tsl.state);
        }
      }
    } else if (name == 'tsl') {
      if (params.tsl.state == 'enabled') {
        params.tsl.content = 'collapse';
      } else {
        if (params.tsl.collapsed) {
          params.tsl.content = '';
        }
      }
    } else if (name == 'order_adjustment') {
      if (params.order_adjustment.state == 'enabled') {
        params.order_adjustment.content = 'collapse';
      } else {
        if (params.order_adjustment.collapsed) {
          params.order_adjustment.content = '';
        }
        params.order_adjustment.sl.state = 'disabled';
        params.order_adjustment.tgt.state = 'disabled';
      }
      this.updateSLTgtContent(params, 'order_adjustment_sl');
      this.updateSLTgtContent(params, 'order_adjustment_tgt');
    } else if (name == 'order_adjustment_sl') {
      if (params.order_adjustment.sl.state == 'enabled') {
        let sl_texts: any = { pts: 'Points', percent: 'Percent' };
        if (params.order_adjustment.sl.type == '') {
          this.strategyParams.order_adjustment.sl['type'] = 'percent';
          this.strategyParams.order_adjustment.sl['value'] = 10;
        }
        this.strategyParams.order_adjustment.sl['type_text'] = sl_texts[this.strategyParams.order_adjustment.sl["type"]];
      } else {
        if (params.order_adjustment.sl.type != '') {
          this.strategyParams.order_adjustment.sl['type'] = '';
          this.strategyParams.order_adjustment.sl['value'] = '';
          this.strategyParams.order_adjustment.sl['type_text'] = "Select";
        }
      }
    } else if (name == 'order_adjustment_tgt') {
      if (params.order_adjustment.tgt.state == 'enabled') {
        let tgt_texts: any = { pts: 'Points', percent: 'Percent' };
        if (params.order_adjustment.tgt.type == '') {
          this.strategyParams.order_adjustment.tgt['type'] = 'percent';
          this.strategyParams.order_adjustment.tgt['value'] = 10;
        }
        this.strategyParams.order_adjustment.tgt['type_text'] = tgt_texts[this.strategyParams.order_adjustment.tgt["type"]];
      } else {
        if (params.order_adjustment.tgt.type != '') {
          this.strategyParams.order_adjustment.tgt['type'] = '';
          this.strategyParams.order_adjustment.tgt['value'] = '';
          this.strategyParams.order_adjustment.tgt['type_text'] = "Select";
        }
      }
    }
  }

  onSLTgtCheckChange(params: any, event: any, name: any) {
    if (name == 'tgt') {
      params.tgt.state = event.target.checked ? 'enabled' : 'disabled';
    } else if (name == 'sl') {
      params.sl.state = event.target.checked ? 'enabled' : 'disabled';
    } else if (name == 'tsl') {
      params.tsl.state = event.target.checked ? 'enabled' : 'disabled';
    } else if (name == 'order_adjustment') {
      params.order_adjustment.state = event.target.checked ? 'enabled' : 'disabled';
    } else if (name == 'order_adjustment_sl') {
      params.order_adjustment.sl.state = event.target.checked ? 'enabled' : 'disabled';
    } else if (name == 'order_adjustment_tgt') {
      params.order_adjustment.tgt.state = event.target.checked ? 'enabled' : 'disabled';
    }
    this.updateSLTgtContent(params, name);
  }

  onTSLCTCCheckChange(params: any, event: any) {
    params.tsl.ctc = event.target.checked ? 1 : 0;
  }

  ptClass(params: any, bt_name: any) {
    if (params.pt == bt_name) {
      return { 'btn-primary': 1 }
    }
    return { 'btn-secondary': 1 }
  }

  onPTSelect(params: any, bt_name: any) {
    params.pt = bt_name;
  }

  modeClass(params: any, bt_name: any) {
    if (params.run_mode.which == bt_name) {
      return { 'btn-success': 1 }
    }
    return { 'btn-outline-secondary': 1 }
  }

  onModeSelect(params: any, bt_name: any) {
    params.run_mode.which = bt_name;
    this.setRunmodeParams(params);
  }

  alertSourceClass(params: any, bt_name: any) {
    if (bt_name == params.run_mode.value.telegram_source) {
      return { 'active': 1 }
    }
    return { }
  }

  onAlertSourceSelected(params: any, run_mode_id: any) {
    let rtype: any = this.getRunmodeType(run_mode_id);
    params.run_mode.value.telegram_source = rtype._id;
    params.run_mode.value.telegram_source_text = rtype.name;
  }

  ttClass(params: any, bt_name: any) {
    if (params.tt == bt_name) {
      if (bt_name == 'buy') {
        return { 'btn-success': 1 }
      } else if (bt_name == 'sell') {
        return { 'btn-danger': 1 }
      }
    }
    return { 'btn-secondary': 1 }
  }

  onTTSelect(params: any, bt_name: any) {
    params.tt = bt_name;
    this.setSSSParams(params, params.ss.segment, null);
    this.setSLParams(params);
  }

  reenterClass(params: any, bt_name: any, rkey: any) {
    if (bt_name == params.reenter[rkey]) {
      return { 'active': 1 }
    }
    return { }
  }

  onReenterStateChanged(params: any, event: any) {
    let state: any = event.target.checked ? 'enabled' : 'disabled';
    this.setReenterParams(params, state);
  }

  onReenterSelect(params: any, bt_name: any) {
    let same_selection: any = (params.reenter.on == bt_name);
    params.reenter.on = bt_name;
    if (!same_selection) {
      this.setReenterParams(params, params.reenter.state);
    }
  }

  onReenterWhatSelect(params: any, bt_name: any) {
    let same_selection: any = (params.reenter.what == bt_name);
    params.reenter.what = bt_name;
    if (!same_selection) {
      this.setReenterParams(params, params.reenter.state);
    }
  }

  onReenterFreqSelect(params: any, bt_name: any) {
    let same_selection: any = (params.reenter.freq == bt_name);
    params.reenter.freq = bt_name;
    if (!same_selection) {
      this.setReenterParams(params, params.reenter.state);
    }
  }

  setReenterParams(params: any, state: any) {
    params.reenter.types = CONSTANTS.ORB_REENTRY_ON_TYPES;
    params.reenter.whats = CONSTANTS.ORB_REENTRY_WHAT_TYPES;
    params.reenter.freqs = CONSTANTS.ORB_REENTRY_FREQ_TYPES;
    params.reenter.state = state;
    if (params.reenter.state == 'enabled') {
      let rtype = this.getReenterTypeById(params.reenter.on, params.reenter.types);
      if (rtype != null) {
        params.reenter.on_text = rtype.name;
      } else {
        params.reenter.on = params.reenter.types[0]._id;
        rtype = this.getReenterTypeById(params.reenter.on, params.reenter.types);
        params.reenter.on_text = rtype.name;
      }
      let wtype = this.getReenterWhatById(params.reenter.what, params.reenter.whats);
      if (wtype != null) {
        params.reenter.what_text = wtype.name;
      } else {
        params.reenter.what = params.reenter.whats[0]._id;
        wtype = this.getReenterWhatById(params.reenter.what, params.reenter.whats);
        params.reenter.what_text = wtype.name;
      }
      let ftype = this.getReenterFreqById(params.reenter.freq, params.reenter.freqs);
      if (ftype != null) {
        params.reenter.freq_text = ftype.name;
      } else {
        params.reenter.freq = params.reenter.freqs[0]._id;
        ftype = this.getReenterFreqById(params.reenter.freq, params.reenter.freqs);
        params.reenter.freq_text = ftype.name;
      }
    } else {
      params.reenter.on = '';
      params.reenter.what = '';
      params.reenter.freq = '';
      params.reenter.on_text = 'On';
      params.reenter.what_text = 'What';
      params.reenter.freq_text = 'On';
    }
  }

  onSSSelect(params: any, bt_name: any) {
    let same_selection: any = (params.ss.type == bt_name);
    if (!same_selection) {
      this.setSSParams(params, bt_name);
    }
  }

  onSSSSelect(params: any, bt_name: any) {
    let same_selection: any = (params.ss.segment == bt_name);
    if (!same_selection) {
      this.setSSSParams(params, bt_name, null);
    }
  }

  onIntervalChanged(params: any) {
    params['interval'] = this.getInterval(params.selectedIntervalId);
  }

  setSSParams(params: any, type_id: any) {
    params.ss = params.ss || {};
    params.ss.type = type_id;
    let types: any = this.get_ss_segment_types(params.ss.segment, params.tt);
    let t: any = this.getSSTypesById(type_id, types);
    params.ss.name = t.name;
    params.ss.max_enabled = t.max_enabled;
    params.ss.min_holder = t.min_holder;
    params.ss.max_length_enabled = t.max_length_enabled;
    params.ss.min_length_enabled = t.min_length_enabled;
    params.ss.max_holder = t.max_holder;
    params.ss.min_length_holder = t.min_length_holder;
    params.ss.max_length_holder = t.max_length_holder;
    if (t.inc == 'strike') {
      params.ss.step = `${params.strike_diff}`;
      params.ss.min = `${(params.strike_diff * 50) * -1}`;
      params.ss.max = `${(params.strike_diff * 50)}`;
    } else {
        params.ss.step = '1';
        params.ss.min = '1';
        params.ss.max = '3000';
        params.ss.step_min_length = '1';
        params.ss.min_min_length = '0';
        params.ss.max_min_length = '3000';
        params.ss.step_max_length = '1';
        params.ss.min_max_length = '0';
        params.ss.max_max_length = '3000';
    }
  }

  setSSSParams(params: any, segment: any, default_type: any) {
    params.ss = params.ss || {};
    params.ss.segment = segment;
    let s: any = this.getSSSegmentById(params.ss.segment);
    params.ss.segment_name = s.name;
    params.ss.types = this.get_ss_segment_types(params.ss.segment, params.tt);
    let t: any = null;
    if (default_type != null) {
      t = this.getSSTypesById(default_type, params.ss.types);
    }
    if (t == null) {
      this.setSSParams(params, params.ss.types[0]._id);
    } else {
      this.setSSParams(params, t._id);
    }
  }

  setRunmodeParams(params: any) {
    if (params.run_mode['which'] == 'paper') {
      params.run_mode.types = CONSTANTS.ORB_RUNMODE_TELEGRAM_TYPES;
      params.run_mode['value'] = {
        telegram_id: params.run_mode?.value?.telegram_id,
        telegram_source: params.run_mode?.value?.telegram_source,
        telegram_source_text: this.getRunmodeType(params.run_mode?.value?.telegram_source)?.name,
      };
    }
  }

  setSLParams(params: any) {
    if (params["sl"]["state"] == 'disabled') {
      params['sl']['content'] = "";
      params['sl']['type'] = "";
      params['sl']['type_text'] = "Select";
      params['sl']['value'] = "";
      params['sl']['value_type'] = "";
      params['sl']['value_type_text'] = "Select";
      params['sl']['max_value'] = "";
      params['sl']['min_value'] = "";
    } else {
      let types: any = this.getSLTypes(params.tt);
      let t: any, lt: any;
      if (params["sl"]["type"]) {
        t = this.getTypeById(params["sl"]["type"], types);
        lt = this.getTypeById(params["sl"]["value_type"], CONSTANTS.VALUE_TYPES);
      } else {
        let dt: any = this.getDefaultType(types);
        let dlt: any = this.getDefaultType(CONSTANTS.VALUE_TYPES);
        t = this.getTypeById(dt._id, types);
        lt = this.getTypeById(dlt._id, CONSTANTS.VALUE_TYPES);
      }
      params['sl']['types'] = types;
      params['sl']['value_types'] = CONSTANTS.VALUE_TYPES;
      params['sl']['type'] = t._id;
      params['sl']['type_text'] = t.name;
      params['sl']['value_type'] = lt._id;
      params['sl']['value_type_text'] = lt.name;
      params['sl']['value'] = (params.sl?.value || params.sl.value === 0) ? params.sl.value : lt.default_value;
      if (t.min_enabled) {
        params['sl']['min_value'] = (params.sl?.min_value || params.sl.min_value == 0) ? params.sl.min_value : lt.default_value;
      } else {
        params['sl']['min_value'] = '';
      }
      if (t.max_enabled) {
        params['sl']['max_value'] = (params.sl?.max_value || params.sl.max_value === 0) ? params.sl.max_value : lt.default_value;
      } else {
        params['sl']['max_value'] = '';
      }
      params['sl']['min_enabled'] = t.min_enabled;
      params['sl']['max_enabled'] = t.max_enabled;
      params['sl']['min'] = t.min;
      params['sl']['content'] = "collapse";
    }
    return params;
  }

  setTgtParams(params: any) {
    if (params["tgt"]["state"] == 'disabled') {
      params['tgt']['content'] = "";
      params['tgt']['type'] = "";
      params['tgt']['type_text'] = "Select";
      params['tgt']['value_type'] = "";
      params['tgt']['value_type_text'] = "Select";
    } else {
      let types: any = this.getTgtTypes(params.tt);
      let t: any, lt: any;
      if (params["tgt"]["type"]) {
        t = this.getTypeById(params["tgt"]["type"], types);
        lt = this.getTypeById(params["tgt"]["value_type"], CONSTANTS.VALUE_TYPES);
      } else {
        let dt: any = this.getDefaultType(types);
        let dlt: any = this.getDefaultType(CONSTANTS.VALUE_TYPES);
        t = this.getTypeById(dt._id, types);
        lt = this.getTypeById(dlt._id, CONSTANTS.VALUE_TYPES);
      }
      params['tgt']['types'] = types;
      params['tgt']['value_types'] = CONSTANTS.VALUE_TYPES;
      params['tgt']['type'] = t._id;
      params['tgt']['type_text'] = t.name;
      params['tgt']['value_type'] = lt._id;
      params['tgt']['value_type_text'] = lt.name;
      params['tgt']['value'] = params.tgt?.value ? params.tgt.value : lt.default_value;
      params['tgt']['content'] = "collapse";
    }
    return params;
  }

  setTSLParams(params: any, state: any) {
    if (state == 'enabled') {
      let texts: any = { pts: 'Points', percent: 'Percent', '': 'On' };
      params['tsl']['type'] = params["tsl"]["type"] ? params["tsl"]["type"] : '';
      params['tsl']['type_text'] = texts[params['tsl']['type']];
      params['tsl']['content'] = "collapse";
    } else {
      params['tsl']['type'] = "";
      params['tsl']['type_text'] = 'Select';
      params['tsl']['sl'] = "";
      params['tsl']['range'] = "";
      params['tsl']['content'] = "";
    }
    return params;
  }

  ssClass(params: any, bt_name: any) {
    if (bt_name == params.ss.type) {
      return { 'active': 1 }
    }
    return { }
  }

  sssClass(params: any, bt_name: any) {
    if (bt_name == 'spot') {
      if (params.ss.segment == 'spot') {
        return { 'active': 1 }
      }
    } else {
      if (params.ss.segment == 'options') {
        return { 'active': 1 }
      }
    }
    return { }
  }

  has_value(val: any, type: any, step: any) {
    let hasVal: any = false;
    try {
      hasVal = !!parseInt(val);
      if (type == 'default') {
        hasVal = hasVal || (val == 0);
      } else {
        hasVal = hasVal && (val > 0);
      }
      hasVal = hasVal &&  ((val % step) == 0)
    } catch (e) {
      hasVal = false;
    }
    return hasVal;
  }

  ssValueClass(params: any) {
    params.ss.valid = true;
    params.ss.val_err_text = '';
    let types: any = this.get_ss_segment_types(params.ss.segment, params.tt);
    let t: any = this.getSSTypesById(params.ss.type, types);
    let has_val: any = true, has_min_val: any = this.has_value(params.ss.value.min, params.ss.type, params.ss.step);
    let max_allowed: any = t.max_enabled;
    let has_max_val: any = this.has_value(params.ss.value.max, params.ss.type, params.ss.step);
    let has_min_len_val: any = this.has_value(params.ss.value.min_length, params.ss.type, params.ss.step_min_length);
    let has_max_len_val: any = this.has_value(params.ss.value.max_length, params.ss.type, params.ss.step_max_length);
    if (!has_min_val) {
      has_val = false;
    } else {
      if (max_allowed) {
        if (!has_max_val) {
          has_val = false;
        } 
      }
    }
    if (!has_val) {
      params.ss.valid = false;
      if (!max_allowed) {
        params.ss.val_err_text = `Please provide ${(params.ss.type == 'default') ? 'ATM difference value' : 'proper premium value'}`;
      } else {
        if (!has_min_val) {
          params.ss.val_err_text = `Please provide ${(params.ss.type == 'default') ? 'ATM difference value' : 'proper min value'}`;
        } else {
          params.ss.val_err_text = `Please provide ${(params.ss.type == 'default') ? 'ATM difference value' : 'proper max value'}`;
        }
      }
    } else {
      if (has_min_val) {
        params.ss.valid = (params.ss.type == 'default') ? ((params.ss.value.min % params.ss.step) == 0) : true;
        if (!params.ss.valid) {
          params.ss.val_err_text = `Please provide ${(params.ss.type == 'default') ? `in multiple of ${params.ss.step}` : ''}`;
        } else {
          params.ss.val_err_text = '';
        }
      } 
      if (params.ss.valid) {
        if (max_allowed) {
          params.ss.valid = (params.ss.value.min < params.ss.value.max);
          if (!params.ss.valid) {
            params.ss.val_err_text = `Max Value should be greater than Min Value`;
          } else {
            params.ss.val_err_text = '';
          }
        }
      }
    }
    let has_len_val: any = (has_min_len_val && has_max_len_val);
    if (params.ss.valid && has_len_val) {
      params.ss.valid = (params.ss.value.min_length <= params.ss.value.max_length);
    }
    if (!params.ss.valid) {
      return { 'd-block': 1 };
    }
    return { 'd-block': 0 };
  }

  lotClass(params: any) {
    let lots_val = params.lots.value;
    let has_val = false;
    try {
      lots_val = parseInt(lots_val);
      has_val = true;
    } catch (e) {
    }
    if (has_val && (lots_val > 0)) {
      params.lots.valid = true;
      return { 'd-block': 0 };
    }
    params.lots.valid = false;
    return { 'd-block': 1 };
  }

  tslValueClass(params: any) {
    if (params.tsl.range && (params.tsl.range != "") && params.tsl.sl && (params.tsl.sl != "")) {
      if (params.tsl.sl > params.tsl.range) {
        params.tsl.sl_range_valid = false;
        return { 'd-block': 1 };
      }
    }
    params.tsl.sl_range_valid = true;
    return { 'd-block': 0 };
  }

  timeValueClass(params: any) {
    let msg: any = '';
    if (params.entry_time >= params.buffer_time) {
        msg = 'Entry From time should be lesser than Buffer time';
    } else if (params.entry_time >= params.exit_time) {
        msg = 'Entry From time should be lesser than Exit time';
    }
    if (params.buffer_time >= params.exit_time) {
        msg = 'Buffer time should be lesser than Exit time';
    }
    params.time.valid = (msg == '');
    if (!params.time.valid) {
      params.time.err_msg = msg;
      return { 'd-block': 1 };  
    }
    return { 'd-block': 0 };
  }

  slTgtErrTypeClass(params: any, name: any) {
    if (['sl_type'].indexOf(name) > -1) {
      if (params.sl.state == 'enabled') {
        if (!params.sl.type || (params.sl.type == "")) {
          params.sl.type_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.sl.type_valid = true;
    } else if (['sl_value_type'].indexOf(name) > -1) {
      if (params.sl.state == 'enabled') {
        if (!params.sl.value_type || (params.sl.value_type == "")) {
          params.sl.value_type_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.sl.value_type_valid = true;
    } else if (['tgt_type'].indexOf(name) > -1) {
      if (params.tgt.state == 'enabled') {
        if (!params.tgt.type || (params.tgt.type == "")) {
          params.tgt.type_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.tgt.type_valid = true;
    } else if (['tgt_value_type'].indexOf(name) > -1) {
      if (params.tgt.state == 'enabled') {
        if (!params.tgt.value_type || (params.tgt.value_type == "")) {
          params.tgt.value_type_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.tgt.value_type_valid = true;
    } else if (name == 'tsl') {
      if (params.tsl.state == 'enabled') {
        if ((!params.tsl.type || (params.tsl.type == "")) && (params.tsl.ctc == 0)) {
          params.tsl.type_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.tsl.type_valid = true;
    } else if (name == 'order_adjustment_sl') {
      if (params.order_adjustment.sl.state == 'enabled') {
        if (!params.order_adjustment.sl.type || (params.order_adjustment.sl.type == "")) {
          params.order_adjustment.sl.type_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.order_adjustment.sl.type_valid = true;
    } else if (name == 'order_adjustment_tgt') {
      if (params.order_adjustment.tgt.state == 'enabled') {
        if (!params.order_adjustment.tgt.type || (params.order_adjustment.tgt.type == "")) {
          params.order_adjustment.tgt.type_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.order_adjustment.tgt.type_valid = true;
    }
    return { 'is-invalid': 0 };
  }

  slTgtErrValueClass(params: any, name: any) {
    if (['sl'].indexOf(name) > -1) {
      if (params[name].state == 'enabled') {
        if ((params[name].value === "") || params[name].value < params[name].min) {
          params[name].value_valid = false;
          return { 'is-invalid': 1 };
        }
        if (params[name].max_enabled) {
          if ((params[name].max_value === "") || params[name].max_value < params[name].min) {
            params[name].max_value_valid = false;
            return { 'is-invalid': 1 };
          }
        }
        if (params[name].min_enabled) {
          if ((params[name].min_value === "") || params[name].min_value < params[name].min) {
            params[name].min_value_valid = false;
            return { 'is-invalid': 1 };
          }
        }
      }
      params[name].value_valid = true;
      params[name].max_value_valid = true;
      params[name].min_value_valid = true;
    } else if (['tgt'].indexOf(name) > -1) {
      if (params[name].state == 'enabled') {
        if ((params[name].value === "") || params[name].value <= 0) {
          params[name].value_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params[name].value_valid = true;
    } else if (name == 'tslv') {
      if (params.tsl.state == 'enabled') {
        if (((params.tsl.sl === "") || (params.tsl.sl <= 0)) && (params.tsl.ctc == 0)) {
          params.tsl.value_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.tsl.value_valid = true;
    } else if (name == 'tslr') {
      if (params.tsl.state == 'enabled') {
        if (((params.tsl.range === "") || (params.tsl.range <= 0)) && (params.tsl.ctc == 0)) {
          params.tsl.range_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.tsl.range_valid = true;
    } else if (name == 'order_adjustment_sl') {
      if (params.order_adjustment.sl.state == 'enabled') {
        if ((params.order_adjustment.sl.value === "") || (params.order_adjustment.sl.value <= 0)) {
          params.order_adjustment.sl.value_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.order_adjustment.sl.value_valid = true;
    } else if (name == 'order_adjustment_tgt') {
      if (params.order_adjustment.tgt.state == 'enabled') {
        if ((params.order_adjustment.tgt.value === "") || (params.order_adjustment.tgt.value <= 0)) {
          params.order_adjustment.tgt.value_valid = false;
          return { 'is-invalid': 1 };
        }
      }
      params.order_adjustment.tgt.value_valid = true;
    }
    return { 'is-invalid': 0 };
  }

  numberOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
       return false;
    }
    return true;
  }

  get_ss_segment_types(segment: any, tt: any) {
    let types: any = [];
    if (segment == 'spot') {
      types = CONSTANTS.ORB_SS_SPOT_TYPES;
    } else {
        if (tt == 'buy') {
          types = CONSTANTS.ORB_SS_OPTIONS_BUY_TYPES;
        } else {
          types = CONSTANTS.ORB_SS_OPTIONS_SELL_TYPES;
        }
    }
    return types;
  }

  getRunmodeType(run_mode_id: any) {
    let run_mode_types: any = CONSTANTS.ORB_RUNMODE_TELEGRAM_TYPES;
    let run_mode_type;
    for (let i = 0; i < run_mode_types.length; i++) {
      if (run_mode_types[i]._id == run_mode_id) {
        run_mode_type = run_mode_types[i];
        break;
      }
    }
    return run_mode_type;
  }

  getInterval(interval_id: any) {
    let intervals: any = CONSTANTS.INTERVALS;
    let interval;
    for (let i = 0; i < intervals.length; i++) {
      if (intervals[i]._id == interval_id) {
        interval = intervals[i];
        break;
      }
    }
    return interval;
  }

  getSSTypesById(t_id: any, types: any) {
    let ss_type: any = null;
    for (let i = 0; i < types.length; i++) {
      if (types[i]._id == t_id) {
        ss_type = types[i];
        break;
      }
    }
    return ss_type;
  }

  getReenterTypeById(r_id: any, types: any) {
    let r_type: any = null;
    for (let i = 0; i < types.length; i++) {
      if (types[i]._id == r_id) {
        r_type = types[i];
        break;
      }
    }
    return r_type;
  }

  getReenterWhatById(w_id: any, whats: any) {
    let w_type: any = null;
    for (let i = 0; i < whats.length; i++) {
      if (whats[i]._id == w_id) {
        w_type = whats[i];
        break;
      }
    }
    return w_type;
  }

  getReenterFreqById(f_id: any, freqs: any) {
    let f_type: any = null;
    for (let i = 0; i < freqs.length; i++) {
      if (freqs[i]._id == f_id) {
        f_type = freqs[i];
        break;
      }
    }
    return f_type;
  }

  getTypeById(t_id: any, types: any) {
    let t: any = null;
    for (let i = 0; i < types.length; i++) {
      if (types[i]._id == t_id) {
        t = types[i];
        break;
      }
    }
    return t;
  }

  getSLTypes(entry_side: any) {
    if (entry_side == 'buy') {
      return CONSTANTS.ORB_SL_BUY_TYPES;
    } else {
      return CONSTANTS.ORB_SL_SELL_TYPES;
    }
  }

  getTgtTypes(entry_side: any) {
    if (entry_side == 'buy') {
      return CONSTANTS.ORB_TGT_BUY_TYPES;
    } else {
      return CONSTANTS.ORB_TGT_SELL_TYPES;
    }
  }

  getDefaultType(types: any) {
    for (let i = 0; i < types.length; i++) {
      if (types[i].default) {
        return types[i];
      }
    }
  }

  getIntervalId(interval: any) {
    let intervals: any = CONSTANTS.INTERVALS;
    let interval_id = -1;
    for (let i = 0; i < intervals.length; i++) {
      if (intervals[i].name == interval) {
        interval_id = intervals[i]._id;
        break;
      }
    }
    return interval_id;
  }

  getSymbolByName(trading_symbol: any) {
    let symbol;
    for (let i = 0; i < this.symbols.length; i++) {
      if (this.symbols[i].trading_symbol == trading_symbol) {
        symbol = this.symbols[i];
        break;
      }
    }
    return symbol;
  }

  getSSSegmentById(segment_id: any) {
    let segment;
    for (let i = 0; i < this.ss_segments.length; i++) {
      if (this.ss_segments[i]._id == segment_id) {
        segment = this.ss_segments[i];
        break;
      }
    }
    return segment;
  }

  populateDatas() {
    this.categories = this.dataService.getCategories();
    this.segments = this.dataService.getSegments();
    this.symbols = this.params.symbols;
  }

  populateOpenStrategyModal() {
    let original = this.strategy["original"];
    let settings = JSON.parse(JSON.stringify(original["settings"]));
    let days: any = CONSTANTS.DAYS;
    this.strategyParams['category'] = settings["category"];
    this.strategyParams['segment'] = settings["segment"]; 
    this.strategyParams['symbol'] = this.getSymbolByName(settings["symbol"]["trading_symbol"]);
    this.strategyParams['trading_symbol'] = this.strategyParams["symbol"]["trading_symbol"];
    this.strategyParams['entry_time'] = settings["entry_time"];
    this.strategyParams['buffer_time'] = settings["buffer_time"];
    this.strategyParams['exit_time'] = settings["exit_time"];
    this.strategyParams['tt'] = settings["entry_side"];
    this.strategyParams['pt'] = settings["trade_type"];
    this.strategyParams['selectedIntervalId'] = `${settings["interval"]}`;
    this.strategyParams['strike_diff'] = settings["strike_diff"];
    this.strategyParams['ss'] = settings['strike_selection'];
    this.strategyParams['order_adjustment'] = settings['order_adjustment'];
    this.strategyParams['ss']['valid'] = true;
    this.strategyParams['ss']['val_err_text'] = '';
    this.strategyParams['reenter'] = settings["reenter"] || { state: 'disabled', count: 0, on_text: 'On', on: '' };
    this.strategyParams['exit_on'] = settings["exit_on"] || { state: 'disabled', type_text: 'On', type: '' };
    this.setSSSParams(this.strategyParams, settings['strike_selection']['segment'].toLowerCase(), settings['strike_selection']['type'].toLowerCase());
    this.setReenterParams(this.strategyParams, this.strategyParams['reenter']['state']);
    this.strategyParams['lots'] = { value: settings["lots"], valid: true };
    this.strategyParams['run_mode'] = settings["run_mode"];
    if (settings.run_mode) {
      this.setRunmodeParams(this.strategyParams);
    }
    if (settings.sl) {
      this.strategyParams['sl'] = settings["sl"];
      this.strategyParams['sl']['collapsed'] = true;
      this.strategyParams = this.setSLParams(this.strategyParams);
    } else {
      this.strategyParams['sl']['content'] = "";
    }
    this.strategyParams['days'] = {};
    for (let i = 0; i < days.length; i++) {
      let d = days[i].toLocaleUpperCase();
      this.strategyParams['days'][d] = (settings['days'].indexOf(d) > -1);
    }
    if (settings.tsl) {
      this.strategyParams['tsl'] = settings.tsl;
      this.strategyParams['tsl']['collapsed'] = true;
      this.strategyParams = this.setTSLParams(this.strategyParams, settings.tsl.state);
    } else {
      this.strategyParams['tsl'] = { type_text: 'Select', state: 'enabled', sl: 0, value: 0 };
    }
    if (settings.tgt) {
      this.strategyParams['tgt'] = settings["tgt"];
      this.strategyParams['tgt']['collapsed'] = true;
      this.strategyParams = this.setTgtParams(this.strategyParams);
    } else {
      this.strategyParams['tgt']['content'] = "";
    }
    this.strategyParams['time'] = {
      err_msg: '',
      valid: true,
      entry_from_msg: '',
      entry_to_msg: ''
    };
  }

  saveSettings(params: any, data: any) {
    if (!this.is_strategy_params_valid()) return;
    let symbol: any = this.strategyParams.symbol.original;
    delete symbol.instrument;
    let interval: any = this.getInterval(this.strategyParams.selectedIntervalId);
    data['settings'] = {
      "category": this.strategyParams.category,
      "segment": this.strategyParams.segment,
      "symbol": symbol,
      "tgt": {
        'state': this.strategyParams.tgt.state,
        'type' : this.strategyParams.tgt.type,
        'value_type' : this.strategyParams.tgt.value_type,
        'value' : this.strategyParams.tgt.value,
      },
      "sl": {
        'state': this.strategyParams.sl.state,
        'type' : this.strategyParams.sl.type,
        'value_type' : this.strategyParams.sl.value_type,
        'value' : this.strategyParams.sl.value,
        'max_value' : this.strategyParams.sl.max_value,
        'min_value' : this.strategyParams.sl.min_value,
      },
      "tsl": {
        'state': this.strategyParams.tsl.state,
        'type' : this.strategyParams.tsl.type,
        'sl' : this.strategyParams.tsl.sl,
        'range' : this.strategyParams.tsl.range,
        'ctc': this.strategyParams.tsl.ctc
      },
      "order_adjustment": {
        'state': this.strategyParams.order_adjustment.state,
        'sl' : {
          state: this.strategyParams.order_adjustment.sl.state,
          type: this.strategyParams.order_adjustment.sl.type,
          value: this.strategyParams.order_adjustment.sl.value
        },
        'tgt' : {
          state: this.strategyParams.order_adjustment.tgt.state,
          type: this.strategyParams.order_adjustment.tgt.type,
          value: this.strategyParams.order_adjustment.tgt.value
        }
      },
      "reenter": {
        'state': this.strategyParams.reenter.state,
        'on' : this.strategyParams.reenter.on,
        'what' : this.strategyParams.reenter.what,
        'freq' : this.strategyParams.reenter.freq,
        'count' : this.strategyParams.reenter.count
      },
      "strike_selection": {
        'segment': this.strategyParams.ss.segment,
        'type': this.strategyParams.ss.type,
        'value' : {
          min: this.strategyParams.ss.value.min,
          max: this.strategyParams.ss.value.max,
          min_length: this.strategyParams.ss.value.min_length || 0,
          max_length: this.strategyParams.ss.value.max_length || 0,
        }
      },
      'run_mode': {
        'which': this.strategyParams.run_mode.which,
        'value': {
          'telegram_source': this.strategyParams.run_mode.value.telegram_source,
          'telegram_id': this.strategyParams.run_mode.value.telegram_id
        },
      },
      'lots': this.strategyParams.lots.value,
      'trade_type': this.strategyParams.pt,
      'entry_side': this.strategyParams.tt,
      'timeframe': interval.name,
      'start_time': this.strategyParams.entry_time,
      'end_time': this.strategyParams.exit_time,
      'buffer_time': this.strategyParams.buffer_time,
    }
    data['settings']['days'] = data['settings']['days'] || []
    for (let key in this.strategyParams.days) {
      if (this.strategyParams.days[key]) {
        data['settings']['days'].push(key.toUpperCase())
      }
    }
    let func;
    if (params.update) {
      func = this.threadService.update;
    } else {
      func = this.threadService.add;
    }
    func.apply(this.threadService, [data]).subscribe((response: any) => {
      if (response.response_code == 1000) {
        if (params.update) {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Updated successfully");
        } else {
          this.notificationService.showAlert(CONSTANTS.SUCCESS, "Added successfully");
        }
        this.dataService.strategyDetailsSaved({ success: true, thread: response.thread });
      } else {
        this.dataService.strategyDetailsSaved({ success: false });
      }
    });
  }

  is_strategy_params_valid() {
    let valid: any = this.strategyParams.lots.valid;
    valid = valid && this.strategyParams.time.valid;
    valid = valid && this.strategyParams.ss.valid;
    valid = valid && this.strategyParams.tgt.type_valid;
    valid = valid && this.strategyParams.tgt.value_valid;
    valid = valid && this.strategyParams.sl.type_valid;
    valid = valid && this.strategyParams.sl.value_valid;
    valid = valid && this.strategyParams.sl.max_value_valid;
    valid = valid && this.strategyParams.sl.min_value_valid;
    valid = valid && this.strategyParams.tsl.type_valid;
    valid = valid && this.strategyParams.tsl.value_valid;
    valid = valid && this.strategyParams.tsl.range_valid;
    valid = valid && this.strategyParams.tsl.sl_range_valid;
    valid = valid && this.strategyParams.order_adjustment.sl.type_valid;
    valid = valid && this.strategyParams.order_adjustment.sl.value_valid;
    valid = valid && this.strategyParams.order_adjustment.tgt.type_valid;
    valid = valid && this.strategyParams.order_adjustment.tgt.value_valid;
    return valid;
  }

  ngOnDestroy(): void {
      if (this.saveSettingsEvent) {
        this.saveSettingsEvent.unsubscribe();
      }
  }
}
